import React from "react";

import { GenericObject } from "src/api/flowTypes";
import { ErrorBlobDisplay } from "src/base-components/ErrorBlobDisplay";
import { ErrorSection } from "src/base-components/ErrorSelector";
import { TableComp as Table } from "src/base-components/Table";
import { getColumns } from "src/dataTable/TableUtils";
import { Callout } from "src/design-system/Callout";

type Props = {
  errorSections: ErrorSection[];
  failingInput?: GenericObject;
  action?: {
    text: string;
    onClick: () => void;
  };
};

// Errors found here from nodes
export const ErrorInfo: React.FC<Props> = ({
  errorSections,
  failingInput,
  action,
}) => {
  return (
    <>
      <Callout action={action} type="error">
        <div
          /*min-w-0 necessary because of the parent flex box */
          className="min-w-0 whitespace-pre-wrap break-words"
        >
          {errorSections.map((section, index) => (
            <div
              key={section.title}
              className={index < errorSections.length - 1 ? "mb-2" : undefined}
            >
              <ErrorBlobDisplay
                errorBlob={section.errorBlob}
                isCodeBlock={section.isCodeBlock}
                title={section.title}
              />
            </div>
          ))}
        </div>
      </Callout>

      {failingInput && (
        <div className="mt-6">
          <div className="mb-4 font-inter-semibold-13px text-gray-800">
            Failing Node input:
          </div>
          <Table
            columns={getColumns([failingInput], "topLeft")}
            data={[failingInput]}
            frameClassName="px-4 border border-gray-200 rounded-lg"
            rowClassName="border-t"
          />
        </div>
      )}
    </>
  );
};
